module.exports = __webpack_public_path__ + "static/media/people.97c680fc.svg";